class MarketoForms {
  constructor() {
    // eslint-disable-next-line
    MktoForms2.whenReady((form) => {
      const formElement = form.getFormElem()[0];
      const submitButton = formElement.querySelector('.mktoButton');
      const formParent = formElement.parentNode;
      const formMessage = formParent.querySelector('[data-element="marketo-form-message"]');
      submitButton.classList.add('btn');

      form.onSuccess(() => {
        formElement.classList.add('marketo-form--hide');
        formMessage.classList.add('marketo-form__message--show');
        formParent.parentNode.parentNode.scrollIntoView({
          behavior: 'smooth',
        });

        return false;
      });
    });
  }
}

const marketo = {
  init() {
    const marketoForms = document.querySelector('[data-module="marketo-form"]');

    if (marketoForms) {
      new MarketoForms();
    }
  },
};

export default marketo;
